import { NgModule } from '@angular/core'
import type { Routes } from '@angular/router'
import { RouterModule } from '@angular/router'

import { OldArticleComponent } from './components/old-article.component'
import { OldMagazineComponent } from './components/old-magazine.component'

const magazineChildren = [
  {
    path: 'uitgave/:uitgaveId',
    component: OldMagazineComponent,
  },
]

const routes: Routes = [
  // Article redirects
  {
    path: 'artikel/:id',
    component: OldArticleComponent,
  },
  {
    path: 'Artikelen/:id',
    component: OldArticleComponent,
  },

  // Magazine redirects
  {
    path: 'Insolventierecht',
    component: OldMagazineComponent,
    data: { magazineId: 16 },
    children: magazineChildren,
  },
  {
    path: 'Compliance',
    component: OldMagazineComponent,
    data: { magazineId: 3 },
    children: magazineChildren,
  },
  {
    path: 'Financieelrecht',
    component: OldMagazineComponent,
    data: { magazineId: 4 },
    children: magazineChildren,
  },
  {
    path: 'HuurrechtBedrijfsruimte',
    component: OldMagazineComponent,
    data: { magazineId: 5 },
    children: magazineChildren,
  },
  {
    path: 'Jaarrekeningenrecht',
    component: OldMagazineComponent,
    data: { magazineId: 7 },
    children: magazineChildren,
  },
  {
    path: 'Energierecht',
    component: OldMagazineComponent,
    data: { magazineId: 8 },
    children: magazineChildren,
  },
  {
    path: 'massclaims',
    component: OldMagazineComponent,
    data: { magazineId: 21 },
    children: magazineChildren,
  },
  {
    path: 'Staatssteun',
    component: OldMagazineComponent,
    data: { magazineId: 10 },
    children: magazineChildren,
  },
  {
    path: 'Internetrecht',
    component: OldMagazineComponent,
    data: { magazineId: 12 },
    children: magazineChildren,
  },
  {
    path: 'SanctierechtOnderneming',
    component: OldMagazineComponent,
    data: { magazineId: 14 },
    children: magazineChildren,
  },
  {
    path: 'arbeidsrechtincontext',
    component: OldMagazineComponent,
    data: { magazineId: 19 },
    children: magazineChildren,
  },
  {
    path: 'Zakenrecht',
    component: OldMagazineComponent,
    data: { magazineId: 18 },
    children: magazineChildren,
  },
  {
    path: 'Levensmiddelenrecht',
    component: OldMagazineComponent,
    data: { magazineId: 30 },
    children: magazineChildren,
  },
  {
    path: 'Kapitaalmarktenrecht',
    component: OldMagazineComponent,
    data: { magazineId: 36 },
    children: magazineChildren,
  },
  {
    path: 'Vastgoedcontracten',
    component: OldMagazineComponent,
    data: { magazineId: 6 },
    children: magazineChildren,
  },

  // /pagina/... redirects
  { path: 'pagina/contact', redirectTo: '/contact' },
  { path: 'pagina/overons', redirectTo: '/about-us' },
  { path: 'pagina/privacystatement', redirectTo: '/privacy-policy' },
  { path: 'pagina/algemenevoorwaarden', redirectTo: '/terms-and-conditions' },
  { path: 'pagina/adverteren', redirectTo: '/advertisement' },
  { path: 'pagina/veelgesteldevragen', redirectTo: '/help' },
  { path: 'pagina/disclaimer', redirectTo: '/terms-and-conditions' },

  // Auth page redirects
  { path: 'inloggen', redirectTo: '/auth/login' },
  { path: 'registreren', redirectTo: '/auth/register' },
  { path: 'wachtwoordvergeten', redirectTo: '/auth/forgot-password' },
  { path: 'emailverificatie', redirectTo: '/auth/verify-account' },

  // Staff page redirects
  { path: 'medewerkers', redirectTo: '/authors' },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OldSiteRoutingModule {}
